<base-support-modal [title]="title" [btnOkClass]="'btn-primary'" [btnOkLabel]="'Установить'" (onOk)="ok()" >
	<p>Выберите премиум-шаблоны для назначения их пользователю<br>(для множественного выделения или его снятия используйте <em>Ctrl + Click</em>):</p>

	<p>
		<select class="form-control" ul-model="premiumTemplates" [(ngModel)]="userTemplates" [ngModelOptions]="{standalone: true}" multiple="multiple">
			<option *ngFor="let template of templates" [value]="template" [selected]="userTemplates.indexOf(template) > -1">{{template}}</option>
		</select>
	</p>
</base-support-modal>

